import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import "./App.css";
import Blogs from "./pages/[blog]";
import Blog from "./pages/blog";
import MapPage from "./pages/map";

export default function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/map">
            <MapPage />
          </Route>
          <Redirect from="/blog/:slug" to="/:slug" />
          <Redirect from="/blog" to="/" />
          <Route exact path="/">
            <Blog />
          </Route>
          <Route path="/:slug">
            <Blogs />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}